import type { BusinessUnitWhatsAppHealth, WhatsAppAlertsPage } from '../types/metrics';
import baseApi from './baseApi';

export interface WhatsAppAlertsRefreshResponse {
  /** false when 360dialog could not be reached — the view falls back to stored records. */
  synced: boolean;
  channels: number;
  recorded: number;
}

const whatsAppHealthApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getWhatsAppHealth: build.query<
      BusinessUnitWhatsAppHealth,
      { businessUnitId: number; startDate?: string; endDate?: string }
    >({
      query: ({ businessUnitId, startDate, endDate }) => {
        const params = new URLSearchParams({ businessUnitId: businessUnitId.toString() });
        if (startDate) params.append('startDate', startDate);
        if (endDate) params.append('endDate', endDate);

        return `/metrics/whatsapp-health?${params.toString()}`;
      },
      providesTags: ['WhatsAppHealth'],
    }),
    getWhatsAppAlerts: build.query<
      WhatsAppAlertsPage,
      {
        businessUnitId: number;
        startDate?: string;
        endDate?: string;
        category?: string;
        page: number;
        pageSize: number;
      }
    >({
      query: ({ businessUnitId, startDate, endDate, category, page, pageSize }) => {
        const params = new URLSearchParams({
          businessUnitId: businessUnitId.toString(),
          page: page.toString(),
          pageSize: pageSize.toString(),
        });
        if (startDate) params.append('startDate', startDate);
        if (endDate) params.append('endDate', endDate);
        if (category) params.append('category', category);

        return `/metrics/whatsapp-health/alerts?${params.toString()}`;
      },
      providesTags: ['WhatsAppHealth'],
    }),
    refreshWhatsAppAlerts: build.mutation<WhatsAppAlertsRefreshResponse, { businessUnitId: number }>({
      query: (body) => ({ url: '/metrics/whatsapp-health/refresh', method: 'POST', body }),
      invalidatesTags: ['WhatsAppHealth'],
    }),
  }),
  overrideExisting: false,
});

export const { useGetWhatsAppHealthQuery, useGetWhatsAppAlertsQuery, useRefreshWhatsAppAlertsMutation } =
  whatsAppHealthApi;
